import { apiService } from "../../../../services/api/apiService";
import { PaginationFilterDto } from "../../../../types/Pagination";
import { downloadCsvFile } from "../../../../utils/downloadCsvFile";
import { TopicDetailDto, TopicDto, TopicImportCsvDto } from "../types";

const BASE_URL = "/topics"

export const getTopicTree = async (): Promise<TopicDto[]> =>
    await apiService.get<TopicDto[]>(`${BASE_URL}/tree`);

export const getTopicDetailById = async (id: number): Promise<TopicDetailDto> =>
    await apiService.get<TopicDetailDto>(`${BASE_URL}/${id}`);

export const createTopic = async (body: TopicDetailDto): Promise<TopicDetailDto> =>
    await apiService.post<TopicDetailDto, TopicDetailDto>(`${BASE_URL}/`, body);

export const updateTopic = async (id: number, body: TopicDetailDto): Promise<TopicDetailDto> =>
    await apiService.put<TopicDetailDto, TopicDetailDto>(`${BASE_URL}/${id}`, body);

export const deleteTopic = async (id: number): Promise<void> =>
    await apiService.put(`${BASE_URL}/delete/${id}`, null);

export const exportTopicsToCsv = async (search: string): Promise<void> => {
    try {
        const result = await apiService.post<PaginationFilterDto, any>(`${BASE_URL}/exportToCsv`, {
            search: search,
            pageNumber: 1,
            pageSize: 1,
            selectedOrganizationalStructureIds: []
        }, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        downloadCsvFile(result, `topics_${getDateTimeWithCsvFormat()}.csv`);
    } catch (error) {
        console.error("Error downloading CSV", error);
        throw error;
    }
}

export const importTopicsFromCsv = async (form: TopicImportCsvDto): Promise<void> => {    
    const formData = new FormData();
    formData.append('Description', form.description);
    formData.append('File', form.file!);

    await apiService.post(`${BASE_URL}/importFromCsv`, formData);
}

export const downloadTopicsTemplate = async () => {    
    const result = await apiService.get<any>(
        `${BASE_URL}/template`,
        {
            responseType: "blob",
        }
    );
    
    downloadCsvFile(result, `topics_template_${getDateTimeWithCsvFormat()}.csv`);
};

const getDateTimeWithCsvFormat = () => {
    const currentDate = new Date()
    const currentDateString =
        currentDate.getFullYear() +
        String(currentDate.getMonth() + 1).padStart(2, '0') +
        String(currentDate.getDate()).padStart(2, '0') +
        String(currentDate.getHours()).padStart(2, '0') +
        String(currentDate.getMinutes()).padStart(2, '0') +
        String(currentDate.getSeconds()).padStart(2, '0');

    return currentDateString;
}